import React from 'react';
import PropTypes from 'prop-types';
import { MarketingBadge } from '@americanexpress/dls-react';
import styles from './LobBadge.scss';

const getBadgeConfig = (lobType) => {
  const configs = {
    guestbook: { label: 'NEW', type: 'corner' },
  };
  return configs[lobType];
};

const LobBadge = ({ lob }) => {
  const badgeConfig = getBadgeConfig(lob);
  if (!lob || !badgeConfig) return null;

  const { label, type } = badgeConfig;

  return <MarketingBadge className={styles.badge} type={type} size="sm">{label}</MarketingBadge>;
};

LobBadge.propTypes = {
  lob: PropTypes.string,
};

export default LobBadge;
